import { Type } from '@angular/core';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MdIconModule, MdRippleModule, PortalModule } from '@angular/material';

import { QuiverCommonModule } from '../common/common.module';

// Steps

import { TdStepsComponent } from './steps.component';
import { TdStepHeaderComponent } from './step-header/step-header.component';
import { TdStepBodyComponent } from './step-body/step-body.component';
import { TdStepComponent, TdStepLabelDirective, TdStepActionsDirective,
         TdStepSummaryDirective } from './step.component';

const /** @type {?} */ TD_STEPS: Type<any>[] = [
  TdStepsComponent,
  TdStepComponent,
  TdStepHeaderComponent,
  TdStepBodyComponent,
  TdStepLabelDirective,
  TdStepActionsDirective,
  TdStepSummaryDirective,
];

export { TdStepComponent, StepState  } from './step.component';
export { TdStepsComponent, IStepChangeEvent, StepMode } from './steps.component';
export class QuiverStepsModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdIconModule,
    MdRippleModule,
    PortalModule,
    QuiverCommonModule,
  ],
  declarations: [
    TD_STEPS,
  ],
  exports: [
    TD_STEPS,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverStepsModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverStepsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverStepsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
